module.exports = __webpack_public_path__ + "static/media/canallightitalic.500df1d4.ttf";